// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: var(--randy-red);
  --background-hover: var(--randy-red-dark);
  --background-activated: var(--randy-red-dark);
  --color: white;
  --border-radius: 12px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-start: 24px;
  --padding-end: 24px;
  font-family: AppFontBold;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  text-transform: none;
  letter-spacing: 0;
  width: 100%;
  height: auto;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,yCAAA;EACA,6CAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EAEA,WAAA;EACA,YAAA;EACA,SAAA;AADD","sourcesContent":["ion-button {\n\t--background: var(--randy-red);\n\t--background-hover: var(--randy-red-dark);\n\t--background-activated: var(--randy-red-dark);\n\t--color: white;\n\t--border-radius: 12px;\n\t--padding-top: 16px;\n\t--padding-bottom: 16px;\n\t--padding-start: 24px;\n\t--padding-end: 24px;\n\t\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tline-height: 22px;\n\ttext-align: center;\n\ttext-transform: none;\n\tletter-spacing: 0;\n\t\n\twidth: 100%;\n\theight: auto;\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
